import { keyframes, css } from '@creditas/stylitas'

import { rtNamespace } from '../variables'

const transformMixin = css`
  transform: translate3d(0, 0, 0);
`

const slideInRight = keyframes`
  from {
    transform: translate3d(110%, 0, 0);
    visibility: visible;
  }
  to {
    ${transformMixin}
  }
`

const slideInLeft = keyframes`
  from {
    transform: translate3d(-110%, 0, 0);
    visibility: visible;
  }
  to {
    ${transformMixin}
  }
`

const slideInUp = keyframes`
  from {
    transform: translate3d(0, 110%, 0);
    visibility: visible;
  }
  to {
    ${transformMixin}
  }
`

const slideInDown = keyframes`
  from {
    transform: translate3d(0, -110%, 0);
    visibility: visible;
  }
  to {
    ${transformMixin}
  }
`

const slideOutRight = keyframes`
  from {
    ${transformMixin}
  }
  to {
    visibility: hidden;
    transform: translate3d(110%, 0, 0);
  }
`

const slideOutLeft = keyframes`
  from {
    ${transformMixin}
  }
  to {
    visibility: hidden;
    transform: translate3d(-110%, 0, 0);
  }
`

const slideOutDown = keyframes`
  from {
    ${transformMixin}
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 500px, 0);
  }
`

const slideOutUp = keyframes`
  from {
    ${transformMixin}
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -500px, 0);
  }
`

const slide = css`
  .${rtNamespace}__slide-enter {
    &--top-left,
    &--bottom-left {
      animation-name: ${slideInLeft};
    }
    &--top-right,
    &--bottom-right {
      animation-name: ${slideInRight};
    }
    &--top-center {
      animation-name: ${slideInDown};
    }
    &--bottom-center {
      animation-name: ${slideInUp};
    }
  }

  .${rtNamespace}__slide-exit {
    &--top-left,
    &--bottom-left {
      animation-name: ${slideOutLeft};
    }
    &--top-right,
    &--bottom-right {
      animation-name: ${slideOutRight};
    }
    &--top-center {
      animation-name: ${slideOutUp};
    }
    &--bottom-center {
      animation-name: ${slideOutDown};
    }
  }
`

export { slide }
